import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { CustomThemeProvider } from './contexts/ThemeContext';
import { Layout } from './components/Layout/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Login } from './pages/Login';
import { Zones } from './pages/Zones';
import { Users } from './pages/Users';
import { UserRole } from './models/User';
function App() {
  return (
    <CustomThemeProvider>
      <AuthProvider>
        <BrowserRouter basename="/">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/login" replace />} />
            
            <Route element={<ProtectedRoute />}>
              <Route element={<Layout />}>
                <Route path="/zones" element={<Zones />} />
                {/* Routes for Hotel Manager */}
                <Route element={<ProtectedRoute allowedRoles={[UserRole.HotelManager]} />}>
                  <Route path="/users" element={<Users />} />
                </Route>

                
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </CustomThemeProvider>
  );
}

export default App;
